import { render, staticRenderFns } from "./LiveSearchItem.vue?vue&type=template&id=aea50e70&lang=pug&"
import script from "./LiveSearchItem.vue?vue&type=script&lang=js&"
export * from "./LiveSearchItem.vue?vue&type=script&lang=js&"
import style0 from "./LiveSearchItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports